"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledBreadcrumbItem = exports.StyledBreadcrumbItemContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  font-size: 14px;\n  font-family: 'Raleway', sans-serif;\n  cursor: pointer;\n  margin-right: 7px;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  line-height: 1;\n\n  ", ":hover {\n    color: ", ";\n  }\n\n  &.pui-breadcrumb-item--active ", " {\n    color: ", ";\n    font-weight: bold;\n  }\n\n  :last-child {\n    margin-right: 0px;\n  }\n\n  :not(:last-child)::after {\n    display: inline;\n    content: \">\";\n    margin: 0px 7px;\n    position: relative;\n    color: inherit;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline;\n  font-size: 14px;\n  font-family: 'Raleway', sans-serif;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledBreadcrumbItemContent = _styledComponents["default"].div(_templateObject());

exports.StyledBreadcrumbItemContent = StyledBreadcrumbItemContent;

var StyledBreadcrumbItem = _styledComponents["default"].div(_templateObject2(), StyledBreadcrumbItemContent, function (props) {
  return props.colorInk;
}, StyledBreadcrumbItemContent, function (props) {
  return props.colorActive;
}); // content: url("${divider}");


exports.StyledBreadcrumbItem = StyledBreadcrumbItem;

function BreadcrumbItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["active", "children", "className"]);

  var theme = (0, _useTheme["default"])();
  var colorActive = theme.palette.primary[500];
  var colorInk = theme.palette.secondary[500];
  return /*#__PURE__*/_react["default"].createElement(StyledBreadcrumbItem, _extends({}, props, {
    colorActive: colorActive,
    colorInk: colorInk,
    className: (0, _clsx["default"])(className, {
      'pui-breadcrumb-item--active': active
    })
  }), /*#__PURE__*/_react["default"].createElement(StyledBreadcrumbItemContent, null, children));
}

BreadcrumbItem.propTypes = {
  active: _propTypes["default"].bool
};
var _default = BreadcrumbItem;
exports["default"] = _default;